import script from "./ShopifyReturn.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopifyReturn.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__